import { render, staticRenderFns } from "./LoaderWidget.vue?vue&type=template&id=e9d7dfbc&"
import script from "./LoaderWidget.vue?vue&type=script&lang=js&"
export * from "./LoaderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports